export default "__VITE_ASSET__Ctc95zgT__"